import React from 'react';
import PropTypes from 'prop-types';
import VerticalSpacer from '../../components_common/VerticalSpacer';
import BrowseTitle from './styled/BrowseTitle';
import BrowseText from './styled/BrowseText';
import { Wrapper } from '../../components_desktop/css_global/utils.css';

const BrowseTilesHeader = ({ children, title }) => (
  <Wrapper textAlign="center">
    <BrowseTitle fontSize="15px">{title}</BrowseTitle>
    <VerticalSpacer height="20px" />
    <BrowseText>{children}</BrowseText>
  </Wrapper>
);

BrowseTilesHeader.propTypes = {
  title: PropTypes.string.isRequired
};

export default BrowseTilesHeader;
